import { Component, input } from '@angular/core';
import { ConsumptionVariance } from '@app/models/dyeing-dashboard/batch-consumption-estimate';

@Component({
  selector: 'app-consumption-variance',
  templateUrl: './consumption-variance.component.html',
})
export class ConsumptionVarianceComponent {
  variance = input<ConsumptionVariance | null>(null);
  unit = input<string>('kg');
}
